import { render, staticRenderFns } from "./SendModal.vue?vue&type=template&id=b0e5061a&scoped=true"
import script from "./SendModal.vue?vue&type=script&lang=js"
export * from "./SendModal.vue?vue&type=script&lang=js"
import style0 from "./SendModal.vue?vue&type=style&index=0&id=b0e5061a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e5061a",
  null
  
)

export default component.exports